import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router";
import "./User.css";
import PropertyMatches from "./Tenant/Matches";
import MatchContainer from "../../containers/MatchContainer";
import TenantMatches from "./Landlord/Matches";
import LandlordPropertyInfo from "./Landlord/LandlordPropertyInfo";
import TenantProfileInfo from "./Tenant/TenantProfileInfo";
import Announcement from "./Landlord/Announcement";
import DashboardContainer from "../../containers/DashboardContainer";
import Editor from "./Shared/Edit/Editor";
import Header from "../Header";

const tenantRoutes = [
    {
        name: "matches",
        title: "Matches",
        component: ( props ) => ( <MatchContainer component={PropertyMatches} {...props}/> )
    },
    {
        name: "information",
        title: "Profile",
        component: TenantProfileInfo
    },
    {
        name: "dashboard",
        title: "Dashboard",
        component: () => ( <DashboardContainer /> )
    },
    {
        name: "edit",
        hidden: true,
        component: Editor
    }
]

const landlordRoutes = [
    {
        name: "announcements",
        title: "Announcements",
        component: Announcement
    },
    {
        name: "matches",
        title: "Matches",
        component: ( props ) => ( <MatchContainer component={TenantMatches} {...props}/> )
    },
    {
        name: "information",
        title: "Details",
        component: (props) => (<LandlordPropertyInfo {...props}/>)
    },
    {
        name: "dashboard",
        title: "Dashboard",
        component: () => ( <DashboardContainer />)
    },
    {
        name: "edit",
        hidden: true,
        component: Editor
    }
]

const defaultTenantRoute = "/user/matches";
const defaultLandlordRoute = "/user/announcements";
const defaultAdminRoute = "/admin";

export default class User extends Component {

    render() {
        const { landlord, user } = this.props;
        const routes = landlord ? landlordRoutes : tenantRoutes;
        return (
            <Switch>
                <Route path="/user/:subRoute" render={( props ) => {
                    const subRoute = props.match.params.subRoute;
                    const index = routes.findIndex( route => route.name === subRoute );
                    if ( index === -1 )
                        return ( <Redirect to={defaultTenantRoute}/> );
                    const Page = routes[index].component;
                    return (
                        <Fragment>
                            <Header admin={user.isAdmin} landlord={landlord} subRoute={subRoute} routes={routes} index={index} buttons/>

                            <Page routeProps={props} {...this.props}/> {/* Forces re-render when the route changes */}
                        </Fragment>
                    ); }} />
                <Redirect to={user.isAdmin ? defaultAdminRoute : (landlord ? defaultLandlordRoute : defaultTenantRoute)}/>
            </Switch>
        );
    }

}

User.propTypes = {
    user: PropTypes.object,
    tenant: PropTypes.bool,
    landlord: PropTypes.bool
}
